export const FETCH_CURRENT_GROUP_SUCCESS = 'FETCH_CURRENT_GROUP_SUCCESS';
export const FETCH_CURRENT_GROUP_PENDING = 'FETCH_CURRENT_GROUP_PENDING';
export const FETCH_CURRENT_GROUP_ERROR = 'FETCH_CURRENT_GROUP_ERROR';
export const RESET_CURRENT_GROUP = 'RESET_CURRENT_GROUP';
